export default __webpack_public_path__ + "static/media/setting_arrow_gray.12d09ecc.svg";